import { useState } from "react";
import { Link } from "react-router-dom";
import { LayoutDashboard, Package, CreditCard, Users, MessagesSquare, Flag, Mail, Settings, ArrowLeft, LogOut, Crown, Home, Medal } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { AdminOverview } from "@/admin/AdminOverview";
import { AdminHome } from "@/admin/AdminHome";
import { AdminInfos } from "@/admin/AdminInfos";
import { AdminPayments } from "@/admin/AdminPayments";
import { AdminUsers } from "@/admin/AdminUsers";
import { AdminRoles } from "@/admin/AdminRoles";
import { AdminChats } from "@/admin/AdminChats";
import { AdminReports } from "@/admin/AdminReports";
import { AdminContacts } from "@/admin/AdminContacts";
import { AdminSettings } from "@/admin/AdminSettings";

const NAV = [
  { id: "overview", label: "Genel Bakış", Icon: LayoutDashboard },
  { id: "home", label: "Ana Sayfa & Duyuru", Icon: Home },
  { id: "infos", label: "Bilgiler", Icon: Package },
  { id: "payments", label: "Ödemeler", Icon: CreditCard },
  { id: "users", label: "Kullanıcılar & IP", Icon: Users },
  { id: "roles", label: "Rütbeler", Icon: Medal },
  { id: "chats", label: "Sohbet Kayıtları", Icon: MessagesSquare },
  { id: "reports", label: "Bildirimler", Icon: Flag },
  { id: "contacts", label: "İletişim Mesajları", Icon: Mail },
  { id: "settings", label: "Site Ayarları", Icon: Settings },
];

export default function AdminPage() {
  const { user, logout } = useAuth();
  const [section, setSection] = useState("overview");
  const [chatUser, setChatUser] = useState(null);

  const goChats = (u) => { setChatUser(u); setSection("chats"); };

  return (
    <div className="min-h-screen bg-[#05070D] text-slate-100 flex" data-testid="admin-dashboard-container">
      <aside className="hidden lg:flex w-64 shrink-0 flex-col border-r border-slate-800/80 bg-[#0A0E1A] p-5 sticky top-0 h-screen">
        <div className="flex items-center gap-3 mb-8">
          <div className="h-10 w-10 rounded-xl bg-red-950 border border-red-500/50 flex items-center justify-center"><Crown className="h-5 w-5 text-red-400" /></div>
          <div><p className="font-mono-cx text-[10px] uppercase tracking-[0.3em] text-red-400">Admin</p><p className="font-display font-bold text-slate-50 leading-none">{user?.username}</p></div>
        </div>
        <nav className="space-y-1 flex-1">
          {NAV.map(({ id, label, Icon }) => (
            <button key={id} data-testid={`admin-nav-${id}`} onClick={() => setSection(id)} className={`w-full h-10 rounded-xl px-3 text-sm font-semibold inline-flex items-center gap-3 transition-colors ${section === id ? "bg-slate-800 text-cyan-300" : "text-slate-400 hover:text-slate-100 hover:bg-slate-900"}`}>
              <Icon className="h-4 w-4" /> {label}
            </button>
          ))}
        </nav>
        <div className="space-y-1 pt-4 border-t border-slate-800">
          <Link to="/" data-testid="admin-back-site" className="w-full h-10 rounded-xl px-3 text-sm font-semibold inline-flex items-center gap-3 text-slate-400 hover:text-slate-100 hover:bg-slate-900 transition-colors"><ArrowLeft className="h-4 w-4" /> Siteye Dön</Link>
          <button data-testid="admin-logout" onClick={logout} className="w-full h-10 rounded-xl px-3 text-sm font-semibold inline-flex items-center gap-3 text-slate-400 hover:text-red-300 hover:bg-slate-900 transition-colors"><LogOut className="h-4 w-4" /> Çıkış</button>
        </div>
      </aside>

      <div className="flex-1 min-w-0">
        <div className="lg:hidden sticky top-0 z-30 bg-[#0A0E1A]/95 backdrop-blur-xl border-b border-slate-800 px-4 py-3 flex gap-2 overflow-x-auto">
          {NAV.map(({ id, label }) => (
            <button key={id} onClick={() => setSection(id)} className={`shrink-0 h-9 px-3 rounded-lg text-xs font-semibold ${section === id ? "bg-slate-800 text-cyan-300" : "text-slate-400 bg-slate-900"}`}>{label}</button>
          ))}
          <Link to="/" className="shrink-0 h-9 px-3 rounded-lg text-xs font-semibold text-slate-400 bg-slate-900 inline-flex items-center">Site</Link>
        </div>
        <main className="p-4 sm:p-8 max-w-7xl">
          {section === "overview" && <AdminOverview />}
          {section === "home" && <AdminHome />}
          {section === "infos" && <AdminInfos />}
          {section === "payments" && <AdminPayments />}
          {section === "users" && <AdminUsers onViewChats={goChats} />}
          {section === "roles" && <AdminRoles />}}
          {section === "chats" && <AdminChats initialUser={chatUser} />}
          {section === "reports" && <AdminReports />}
          {section === "contacts" && <AdminContacts />}
          {section === "settings" && <AdminSettings />}
        </main>
      </div>
    </div>
  );
}
